
export default function ServicesHero() {
  return (
    <section className="relative py-24 bg-gradient-to-br from-red-600 to-red-700 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20engineers%20installing%20advanced%20fire%20alarm%20systems%20and%20sprinkler%20equipment%20in%20Qatar%20commercial%20building%2C%20QCDD%20certified%20technicians%20working%20with%20modern%20fire%20protection%20technology%2C%20red%20safety%20equipment%20and%20control%20panels%20in%20clean%20industrial%20setting&width=1920&height=800&seq=services-hero&orientation=landscape')`
        }}
      ></div>
      <div className="relative container mx-auto px-4 text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Our Fire & Safety Services
        </h1>
        <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
          FlameGuardQA provides complete fire protection and safety solutions — from design and installation 
          to testing, certification, and maintenance. Every service we offer meets QCDD standards and is 
          delivered by certified professionals dedicated to keeping your property safe.
        </p>
      </div>
    </section>
  );
}